import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';
import { withTranslation } from 'react-i18next';
import FormFieldCheckInputOption from './FormFieldCheckInputOption';

class FormFieldControl extends React.Component {

  static propTypes = {
    t: PropTypes.any.isRequired,
    fieldName: PropTypes.string.isRequired,
    fieldNameId: PropTypes.string,
    placeholderId: PropTypes.string,
    controlType: PropTypes.string,
    value: PropTypes.any,
    options: PropTypes.any,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
    readOnly: PropTypes.bool,
    invalid: PropTypes.bool,
    loading: PropTypes.bool,
    validateRequestId: PropTypes.string, //send unique value to trigger validation
  };

  constructor(props) {
    super(props);
  }

  getValueFromElement(element) {
    let {
      controlType,
    } = this.props;

    let value = element.value?element.value:'';

    if (['radio'].includes(controlType)) {
      if (!element.checked) {
        value = undefined;
      }
    } else if (['checkbox'].includes(controlType)) {
      value = [];
      let siblings = document.getElementsByName(this.props.fieldName);
      for (let sibling of siblings) {
        if (sibling.tagName.toUpperCase()==='INPUT') {
          if (sibling.checked) {
            value.push(sibling.getAttribute('value'));
          }
        }
      }
    }

    return value;
  }

  onBlur(e) {
    let value = this.getValueFromElement(e.target);
    if (this.props.onBlur) {
      this.props.onBlur(this.props.fieldName, value);
    }
  }

  onChange(e) {
    let value = this.getValueFromElement(e.target);
    if (this.props.onChange) {
      this.props.onChange(this.props.fieldName, value);
    }
  }

  onUpdateField(fieldName, value, inputValue) {
    if (this.props.onChange) {
      this.props.onChange(this.props.fieldName, value, inputValue);
    }
  }

  render() {

    let {
      t,
      fieldName,
      controlType,
      placeholderId,
      readOnly = false,
      invalid,
      value,
      loading,
    } = this.props;

    let placeholder = placeholderId?t(placeholderId):undefined;

    let options = undefined;
    let selectedLabel = undefined;
    let selectedValues = Array.isArray(value)?value:[value];

    if (Array.isArray(this.props.options)) {
      options = this.props.options.map((option, index) => {
        let optionValue = option;
        let display = option;
        if (Array.isArray(option)) {
          optionValue = option[0];
          display = option.length==1?option[0]:option[1];

          if (value === optionValue) selectedLabel = display;

          if (['checkbox', 'radio'].includes(controlType)) {
            return <Form.Check key={index}
                               id={`formcheck-${fieldName}-${index}`}
                               inline name={fieldName}
                               label={display}
                               value={optionValue}
                               checked={selectedValues.includes(optionValue)}
                               disabled={readOnly}
                               type={controlType}
                               feedback={undefined}
                               onChange={::this.onChange}
                               onBlur={::this.onBlur} />
          } else {
            return <option key={index} value={optionValue}>{display}</option>
          }

        } else if (option && option.type) {
          if (['checkbox', 'radio'].includes(controlType)) {
            return <FormFieldCheckInputOption key={index}
                                              id={`formcheck-${fieldName}-${index}`}
                                              controlType={controlType}
                                              checked={selectedValues.includes(option.value)}
                                              fieldName={fieldName}
                                              onChange={::this.onUpdateField}
                                              onBlur={::this.onUpdateField}
                                              {...option} />

          }
        }



      });

      if (controlType === 'select') {
        options.unshift(<option key={'please_select'} value={''}>{t('pleaseSelect')}</option>)
      }

    }

    return (
      <React.Fragment>
        {['checkbox', 'radio'].includes(controlType) &&
        options
        }
        {!['checkbox', 'radio'].includes(controlType) && !readOnly && !loading &&
        <Form.Control size="lg"
                      as={controlType}
                      name={fieldName}
                      placeholder={placeholder}
                      isInvalid={invalid}
                      value={value}
                      onBlur={::this.onBlur}
                      onChange={::this.onChange}>
          {controlType === 'select'?options:undefined}
        </Form.Control>
        }
        {!['checkbox', 'radio'].includes(controlType) && !readOnly && loading &&
        <Form.Control as={controlType}
                      name={fieldName}
                      placeholder={'Loading ...'}
                      isInvalid={false}
                      disabled={true}
                      value={''}>
          {controlType === 'select' &&
            <option value={''}>{this.props.t('loading')}</option>
          }
        </Form.Control>
        }
        {!['checkbox', 'radio'].includes(controlType) && readOnly && !!selectedLabel &&
        <span>{selectedLabel}</span>
        }
        {!['checkbox', 'radio'].includes(controlType) && readOnly && !!!selectedLabel &&
        <span>{value}</span>
        }
      </React.Fragment>
    )
  }

}

export default withTranslation()(FormFieldControl);
